var BookingID;
window.BookingDetailsData = null;
window.RoomPingDataBooking = null;

var AllMainContentSection;
window.SubmitExperienceButton = null;

var PriceContainerToAddAddOn;

var BookingNotFoundContainer;

var URLSpecialBookingDetails = null;
var AllowSpecialAddNew = false;


var QRBookingDetailSection = null;

var GuestNameInfoQRText = null;
var TipeTiketInfoQRText = null;
var JumlahTiketInfoContainer = null;
var AddOnsInfoQRText = null;
var TanggalKunjunganInfoQRText = null;
var LokasiInfoQRText = null;
var StatusTiketInfoContainer = null;
var DownloadETicketPDFQRButton = null;

// =============================== PERPARE LANG UI ==================================

window.PrepareBookingDetailsUI = function()
{
    // If Special URL ----------------------------------

    let CurrentUrl = new URL(window.location.href);
    let url = new URLSearchParams(window.location.search);

    if(url.has("info"))
    {
        URLSpecialBookingDetails = CurrentUrl.searchParams.get("info");
        AllowSpecialAddNew = true;
    }

    BookingID = window.location.pathname.split("/")?.pop()?.split(".")[0];

    // What Page is This ----------------------
    document.getElementById("WhichPageSectionIsText").innerHTML = window["BookingDetailsTxt" + window.CurrentCountryID];

    // Main Section ----------------------

    
    document.getElementById("SubmitExperienceButtonText").innerHTML = window["ShareExperienceBtnTxt" + window.CurrentCountryID];

    document.getElementById("DownPaymentHeaderText").innerHTML = window["DownPaymentTxt" + window.CurrentCountryID];
    document.getElementById("PaymentMethodHeaderText").innerHTML = window["PaymentMethodTxt" + window.CurrentCountryID];

    document.getElementById("NoPaymentMethodText").innerHTML = window["NoPaymentMethodSelectedTxt" + window.CurrentCountryID];

    document.getElementById("RemainingAmountHeaderText").innerHTML = window["RemainingAmountTxt" + window.CurrentCountryID];

    let ViewMoreExperiencesButtonTextP = document.getElementById("ViewMoreExperiencesButtonTextP");
    if(ViewMoreExperiencesButtonTextP != null)
        ViewMoreExperiencesButtonTextP.innerHTML = window["ViewMoreExpTxt" + window.CurrentCountryID];

    // Not Found Section ----------------------
    
    document.getElementById("BookingNotFoundHeader").innerHTML = window["NoBookingDetailsFoundHeaderTxt" + window.CurrentCountryID];
    document.getElementById("BookingNotFoundMessage").innerHTML = window["NoBookingDetailsFoundMessageTxt" + window.CurrentCountryID];

    // E-Ticket & QR Section ----------------------
    
    document.getElementById("InformasiPentingHeaderQRText").innerHTML = window["InformasiPentingTxt" + window.CurrentCountryID];
    document.getElementById("InformasiPentingInfoQR1Text").innerHTML = window["InformasiPentingInfo1Txt" + window.CurrentCountryID];
    document.getElementById("InformasiPentingInfoQR2Text").innerHTML = window["InformasiPentingInfo2Txt" + window.CurrentCountryID];
    document.getElementById("InformasiPentingInfoQR3Text").innerHTML = window["InformasiPentingInfo3Txt" + window.CurrentCountryID];


    QRBookingDetailSection = document.getElementById("QRBookingDetailSection");

    document.getElementById("ETicketHeaderText").innerHTML = window["ETicketHeaderTxt" + window.CurrentCountryID];
    document.getElementById("TunjukanQRInMessageText").innerHTML = window["ShowThisQRUponMesTxt" + window.CurrentCountryID];

    document.getElementById("TicketIDHeaderText").innerHTML = window["TicketIDTxt" + window.CurrentCountryID];
    
    
    document.getElementById("GuestNameHeaderQRText").innerHTML = window["TicketIDTxt" + window.CurrentCountryID];
    GuestNameInfoQRText = document.getElementById("GuestNameInfoQRText");

    document.getElementById("TipeTiketHeaderQRText").innerHTML = window["TipeTiketTxt" + window.CurrentCountryID];
    TipeTiketInfoQRText = document.getElementById("TipeTiketInfoQRText");

    document.getElementById("JumlahTiketHeaderQRText").innerHTML = window["JumlahTiketTxt" + window.CurrentCountryID];
    JumlahTiketInfoContainer = document.getElementById("JumlahTiketInfoContainer");

    document.getElementById("AddOnsHeaderQRText").innerHTML = window["AddOnsTxt" + window.CurrentCountryID];
    AddOnsInfoQRText = document.getElementById("AddOnsInfoQRText");

    document.getElementById("TanggalKunjunganHeaderQRText").innerHTML = window["TanggalKunjunganTxt" + window.CurrentCountryID];
    TanggalKunjunganInfoQRText = document.getElementById("TanggalKunjunganInfoQRText");

    document.getElementById("LokasiHeaderQRText").innerHTML = window["LocationTxt" + window.CurrentCountryID];
    LokasiInfoQRText = document.getElementById("LokasiInfoQRText");

    document.getElementById("StatusTiketQRHeaderText").innerHTML = window["StatusTicketTxt" + window.CurrentCountryID];
    StatusTiketInfoContainer = document.getElementById("StatusTiketInfoContainer");

    DownloadETicketPDFQRButton = document.getElementById("DownloadETicketPDFQRButton");
    document.getElementById("DownloadETicketPDFQRButtonText").innerHTML = window["DownloadETicketTxt" + window.CurrentCountryID];

}


// ============================== LOAD BOOKING DETAILS ======================================

window.LoadBookingDetails = function(maininfo, basicinfo, loggedin)
{
    // Get Booking ID ----------------------------------------

    // let CurrentUrl = new URL(window.location.href);
    // let param = new URLSearchParams(CurrentUrl.search.slice(1));

    // ----------------------------------------------------------------------------------------

    AllMainContentSection = document.getElementById("AllMainContentSection");
    window.SubmitExperienceButton = document.getElementById("SubmitExperienceButton");
    BookingNotFoundContainer = document.getElementById("BookingNotFoundContainer");
    PriceContainerToAddAddOn = document.querySelectorAll('.PriceContainerToAddAddOn');

    if(loggedin == true && BookingID)
    {
        let LoadBookingBlocker = window.InstantiateLoadingBlocker("LoadBookingBlocker");

        let BookingDetailsURL = "/v2/bookings/" + BookingID + "?lang=" + window.CurrentCountryID;

        window.CallApiAxios({
            method: "GET",
            url: BookingDetailsURL,
        }).then(res =>
        {
            console.log(BookingDetailsURL);
            console.log(res);

            if(res.status == 200)
            {
                window.BookingDetailsData = res.data.data;
                window.HotelDetails = window.BookingDetailsData.hotel;
                window.RoomPingDataBooking = window.BookingDetailsData.booking_details[0];
                console.log("Booking Data-----------------------")
                console.log(window.BookingDetailsData);
                console.log("Hotel Data-----------------------")
                console.log(window.HotelDetails);
                let WhichRoomToAdd = [window.BookingDetailsData.booking_details[0].room_ping.hotel_room];
                window.HotelDetails.rooms = WhichRoomToAdd;
                window.HotelID = window.HotelDetails.id_hotel;
                console.log("Ping Data-----------------------")
                console.log(window.RoomPingDataBooking);

                if(window.BookingDetailsData.booking_details != null && window.BookingDetailsData.booking_details.length > 0)
                {
                    // ===================== ORDER NUMBER =====================================================================================
                    let OrderNumberText = document.getElementById("OrderNumberText");
                    OrderNumberText.innerHTML = window["OrderNumberTxt" + window.CurrentCountryID] + " : ";

                    let OrderNumberCode = document.createElement("span");
                    OrderNumberCode.className = "InterMediumItalicTextFont HyperlinkUnderlineText";
                    OrderNumberCode.innerHTML = window.BookingDetailsData.order_code;
                    OrderNumberCode.onclick = function()
                    {
                        window.CopyToClipboardItem(window.BookingDetailsData.order_code);
                    }
                    OrderNumberText.append(OrderNumberCode);

                    // ===================== YOU HAVE FINISHED =====================================================================================
                    document.getElementById("YouHaveFinishedBookMesText").innerHTML = window["YouHaveBookedPreviouslyMesTxt" + window.CurrentCountryID](window.HotelDetails.hotel_name);

                    // ============================== SHARE BOOKING ==============================

                    document.getElementById("ShareAccommodationButtonWrapper").style.display = "";
                    document.getElementById('ShareAccommodationButton').onclick = function()
                    {
                        window.CheckBookingImageExist(BookingID, loggedin);
                    }

                    // ===================== APPLY REMAINING CHANGES ==============================

                    ApplyChangesBookingDetails(loggedin);
                    BookingNotFoundContainer.remove();
                    window.LoadExprezyDataBookingDetails(window.BookingDetailsData.booking_reference, maininfo, basicinfo, window.BookingDetailsData.id_hotel);
                }
                else
                {
                    // Display No Booking Found 
                    AllMainContentSection.remove();
                    BookingNotFoundContainer.style.display = "";
                }
            }
            LoadBookingBlocker.remove();
        })
        .catch(err =>
        {
            console.error(err);
            LoadBookingBlocker.remove();
            AllMainContentSection.remove();
            BookingNotFoundContainer.style.display = "";
        });
    }
    else
    {
        // Display No Booking Found 
        AllMainContentSection.remove();
        BookingNotFoundContainer.style.display = "";
    }
}

// =============================== APPLY CHANGES =================================

function ApplyChangesBookingDetails(loggedin)
{
    // Image Instantiate -----------------------------------------------------------------------------

    window.LoadRoomPhotoBeforeHotelPhoto("Booking", loggedin);

    // BASIC INFORMATION ------------------------------------

    document.getElementById("AccommodationTypeText").innerHTML = window.HotelDetails.category.category_name;
    document.getElementById("AccommodationNameText").innerHTML = window.HotelDetails.hotel_name;

    document.getElementById("LocationText").innerHTML = window.HotelDetails.location + " - ";

    let seeMapHREF = document.createElement("a");
    seeMapHREF.className = "SeeMapTextInsidePanel InterBoldTextFont HyperlinkUnderlineText";
    seeMapHREF.innerHTML = window["SeeMapTxt" + window.CurrentCountryID];
    seeMapHREF.target = "_blank";
    seeMapHREF.rel = "noopener noreferrer";
    seeMapHREF.href = window.HotelDetails.link_gmaps;
    document.getElementById("LocationText").append(seeMapHREF);

    let HotelDescriptionToDisplay = window.HotelDetails.hotel_description.replace(/(?:\r\n|\r|\n)/g, '<br>');
    HotelDescriptionToDisplay = window.decodeGarbledContent(HotelDescriptionToDisplay);

    document.getElementById("RoomDescriptionText").innerHTML = HotelDescriptionToDisplay;

    document.getElementById("RoomNameAndQuantityTexts").innerHTML = window.BookingDetailsData.total_room + "x <span class='InterRegularTextFont'>" + window.HotelDetails.rooms[0].room_name + "</span>";

    document.getElementById("RoomBenefitsContainer").innerHTML = "";

    document.getElementById("PingExprezyHeaderText").innerHTML = window["WhatYourExperienceInThisHeaderTxt" + window.CurrentCountryID];

    // Benefits ---------------------------------------------------------------

    let RoomBenefitsSwiperSlideContainer = document.getElementById("RoomBenefitsContainer");

    let RoomBenefitsWrapper = document.createElement("div");
    RoomBenefitsWrapper.className = "swiper-wrapper";
    RoomBenefitsSwiperSlideContainer.append(RoomBenefitsWrapper);

    let RoomSmokeTypePanel = document.createElement("div");
    RoomSmokeTypePanel.className = "RoomBenefitsPanel swiper-slide";
    RoomSmokeTypePanel.innerHTML = window.BookingDetailsData.room_preference;
    RoomBenefitsWrapper.append(RoomSmokeTypePanel);

    if(window.HotelDetails.rooms[0].benefits != null)
    {
        for(let i = 0; i < window.HotelDetails.rooms[0].benefits.length; i++)
        {
            let RoomBenefitsSwiper = document.createElement("div");
            RoomBenefitsSwiper.className = "RoomBenefitsPanel swiper-slide";
            RoomBenefitsSwiper.innerHTML = window.HotelDetails.rooms[0].benefits[i]["benefit_name_" + window.CurrentCountryID];
            RoomBenefitsWrapper.append(RoomBenefitsSwiper);
        }
    }

    let RoomBenefitsSwiper = new window.Swiper(RoomBenefitsSwiperSlideContainer,
    {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        observer: true,
        observeParents: true,
        autoplay: {
            delay: 5000,
        },
    });

    // Check In and Out ---------------------------------------------------------------

    let BookingCheckIn = window.BookingDetailsData.date_checkin.split("-");
    let BookingCheckOut = window.BookingDetailsData.date_checkout.split("-");

    document.getElementById("CheckInDateBookingDetailsText").innerHTML = BookingCheckIn[2] + " " + window["monthNames" + window.CurrentCountryID][parseInt(BookingCheckIn[1]) - 1] + " " + BookingCheckIn[0];
    document.getElementById("CheckOutDateBookingDetailsText").innerHTML = BookingCheckOut[2] + " " + window["monthNames" + window.CurrentCountryID][parseInt(BookingCheckOut[1]) - 1] + " " + BookingCheckOut[0];
    
    // Guest Info ---------------------------------------------------------------

    document.getElementById("GuestNameText").innerHTML = window.BookingDetailsData.name_customer;
    document.getElementById("GuestEmailText").innerHTML = window.BookingDetailsData.user.email;
    if(window.BookingDetailsData.user.phone_number != null)
        document.getElementById("GuestPhoneNumberText").innerHTML = "+" + window.BookingDetailsData.user.country_code + window.BookingDetailsData.user.phone_number;


    // Status Related Booking Fee ---------------------------------------------------------------

    let DownPaymentStatusContainer = document.getElementById("DownPaymentStatusContainer");
    DownPaymentStatusContainer.innerHTML = "";

    if(window.BookingDetailsData.status_dp != null)
    {
        if(window.BookingDetailsData.status_dp == "Booking Payment Timeout")
        {
            let statusIcon = document.createElement("img");
            statusIcon.className = "IconInsideRoundedPanel";
            statusIcon.src = "/Assets/images/ButtonIcon/orange-alert-triangle.svg";
            DownPaymentStatusContainer.append(statusIcon);
        }

        let DownPaymentStatusText = document.createElement("p");
        DownPaymentStatusContainer.append(DownPaymentStatusText);

        window.SetBackgroundAndTextColorBasedOnStatus(window.BookingDetailsData.status_dp, DownPaymentStatusContainer);

        if(window.BookingDetailsData.status_dp == "Booking Fee Paid")
        {
            DownPaymentStatusText.innerHTML = window["StatusPaidTxt" + window.CurrentCountryID];
        }
    }
    else
    {
        let DownPaymentStatusText = document.createElement("p");
        DownPaymentStatusContainer.append(DownPaymentStatusText);
        window.SetBackgroundAndTextColorBasedOnStatus("Booking Payment on Progress", DownPaymentStatusContainer);
    }

    // Payment Section Instantiate --------------------------------------------------

    window.InstantiateBookingPaymentData();

    // HIDE LOADING AND DISPLAY INFO -------------------------------------------------------

    let PriceGreyLoading = document.querySelectorAll('.PriceGreyLoading');
    PriceGreyLoading.forEach(ThisLoading =>
    {
        ThisLoading.style.display = "none";
    });

    let TextToDisplayAfterCalc = document.querySelectorAll('.TextToDisplayAfterCalc');
    TextToDisplayAfterCalc.forEach(ThisText =>
    {
        ThisText.style.display = "";
    });

    // Apply Changes To Right Panel Based On Status ----------------------------------

    ApplyChangesBasedOnStatus();
}

function ApplyChangesBasedOnStatus()
{
    // Prepare Elements ========================================================================================================
    let PaymentStatusAndDPWrapper = document.getElementById("PaymentStatusAndDPWrapper");
    let DownPaymentStatusContainer = document.getElementById("DownPaymentStatusContainer");
    let DownPaymentInfoContainer = document.getElementById("DownPaymentInfoContainer");

    let PaymentInfoWrapper = document.getElementById("PaymentInfoWrapper");
    let PaymetMethodIcon = document.getElementById("PaymetMethodIcon");
    let PaymetMethodText = document.getElementById("PaymetMethodText");
    let PaymentVAText = document.getElementById("PaymentVAText");
    let ButtonNextToPayment = document.getElementById("ButtonNextToPayment");
    let ButtonNextToPaymentTextDesktop = document.getElementById("ButtonNextToPaymentTextDesktop");
    let ButtonNextToPaymentTextMobile = document.getElementById("ButtonNextToPaymentTextMobile");

    let NoPaymentSelectedWrapper = document.getElementById("NoPaymentSelectedWrapper");
    let SelectAndPayButton = document.getElementById("SelectAndPayButton");

    let ButtonRefreshPageContainer = document.getElementById("ButtonRefreshPageContainer");

    // Get Data ========================================================================================================
    let BookingPaymentData = window.BookingDetailsData;

    let BookingStatus = null;
    let PaymentStatus = null;

    let MethodBankSelected = null;
    let MethodTypeSelected = null;

    let PaymentDataBasedOnType = null;

    if(BookingPaymentData.payment_method != null)
    {
        BookingStatus = BookingPaymentData.status_pay_at_hotel.status;
        PaymentStatus = BookingPaymentData.status_dp;

        MethodTypeSelected = BookingPaymentData.payment_method;

        if(MethodTypeSelected == "Virtual Account" && BookingPaymentData.transaction.va_transactions.length > 0) // Virtual Account -------------------------------------
        {
            PaymentDataBasedOnType = BookingPaymentData.transaction.va_transactions;
            MethodBankSelected = PaymentDataBasedOnType[0].bank_user;
        }
        else if(MethodTypeSelected == "Direct Transfer" && BookingPaymentData.transaction.direct_transfers.length > 0) // Direct Transfer -------------------------------------
        {
            PaymentDataBasedOnType = BookingPaymentData.transaction.direct_transfers;
            MethodBankSelected = PaymentDataBasedOnType[0].bank_user;
        }
        else if(MethodTypeSelected == "Card" && BookingPaymentData.transaction.card_transactions.length > 0) // Card -------------------------------------
        {
            PaymentDataBasedOnType = BookingPaymentData.transaction.card_transactions;
            MethodBankSelected = PaymentDataBasedOnType[0].card_type;
        }
        else if(MethodTypeSelected == "QRIS")
        {
            PaymentDataBasedOnType = "QRIS";
            MethodBankSelected = "QRIS";
        }
    }
    
    // Set Payment Name and Type ========================================================================================================

    if(MethodTypeSelected == "Virtual Account") // Definitely Method Except Direct Transfer ------------------
    {
        document.getElementById("PaymentMethodNormalContainer").style.display = "";
        document.getElementById("PaymentMethodCardContainer").remove();
        PaymetMethodIcon.src = "/Assets/images/PaymentMethod/" + MethodBankSelected + ".jpg";
        PaymetMethodText.innerHTML = MethodBankSelected + " - " + MethodTypeSelected;
    }
    else if(MethodTypeSelected == "Card")
    {
        document.getElementById("PaymentMethodCardContainer").style.display = "";
        document.getElementById("PaymentMethodNormalContainer").remove();
        if(MethodBankSelected == "debit")
        {
            PaymetMethodText.innerHTML = "Debit Card";
        }
        else
        {
            PaymetMethodText.innerHTML = "Credit Card";
        }
    }
    else
    {
        if(MethodTypeSelected == "Direct Transfer")
        {
            PaymetMethodIcon.src = "/Assets/images/PaymentMethod/BCA.jpg";
            PaymetMethodText.innerHTML = "BCA - Direct Transfer";
            PaymentVAText.innerHTML = "2060770002";
        }
        else if(MethodTypeSelected == "QRIS")
        {
            PaymetMethodIcon.src = "/Assets/images/PaymentMethod/QRIS.jpg";
            PaymetMethodText.innerHTML = "QRIS";
            PaymentVAText.style.display = "none";
        }
        else // Definitely No Payment Found ----------------------------
        {
            PaymetMethodIcon.style.display = "none";
            PaymetMethodText.style.display = "none";
            PaymentVAText.style.display = "none";
        }
    }

    // Apply Based On Status ========================================================================================================
    
    console.log("Down Payment Data", PaymentDataBasedOnType);
    console.log("BookingStatus = " + BookingStatus);
    console.log("PaymentStatus = " + PaymentStatus);

    // No Selected Payment Or Timeout ---------------------------------------------------------------------------------------
    // if(PaymentDataBasedOnType == null || BookingPaymentData.status_dp == "Booking Timeout")
    if(PaymentDataBasedOnType == null)
    {
        PaymentInfoWrapper.style.display = "none";
        NoPaymentSelectedWrapper.style.display = "";

        // Time Out ---------------------
        if(BookingPaymentData.status_dp == "Booking Timeout")
        {
            SelectAndPayButton.style.display = "none";
        }
        // No Payment Method Selected -----------------------------
        else
        {
            SelectAndPayButton.innerHTML = window["SelectandPayTxt" + window.CurrentCountryID];
            SelectAndPayButton.onclick = function()
            {
                window.open("/" + window.CurrentCountryID + "/payment.html?id_booking=" + BookingID, "_blank");
            }
        }
    }
    else
    {
        PaymentInfoWrapper.style.display = "";
        NoPaymentSelectedWrapper.style.display = "none";

        // Booking Fee Paid and Waiting Confirmation from Admin ----------------------------------

        if(PaymentStatus == "Booking Fee Paid" || PaymentStatus == "Waiting for Confirmation")
        {
            PaymentStatusAndDPWrapper.style.display = "flex";

            DownPaymentInfoContainer.style.order = 1;
            DownPaymentInfoContainer.style.flex = 2;

            DownPaymentStatusContainer.style.order = 2;
            DownPaymentStatusContainer.style.marginRight = 0;
            DownPaymentStatusContainer.className = "BookingStatusBookingDetails";

            if(PaymentStatus == "Waiting for Confirmation")
            {
                ButtonRefreshPageContainer.style.display = "";
            }
        }
        // Booking Payment On Going ----------------------------------
        else if(PaymentStatus == "Booking Payment on Progress" || PaymentStatus == "Waiting for Payment" || PaymentStatus == "Waiting Payment") // On Progress ---------------------------
        {
            PaymentVAText.style.display = "";
            
            // Direct Transfer --------------------------------------------------------------
            
            if(MethodTypeSelected == "Direct Transfer")
            {
                alert("This No Longer Supported");
                return
                PaymentVAText.innerHTML = BookingPaymentData.account_number;
                    
                ButtonNextToPayment.style.display = "";
                ButtonNextToPayment.innerHTML = window["VerifyPaymentDirectHyperlinkTxt" + window.CurrentCountryID];
                ButtonNextToPayment.onclick = function()
                {
                    let LoadingBlocker = window.InstantiateLoadingBlocker("DirectTransferBlocker");

                    let DirectTransferURL = "/function/get_direct_transfer.php?id_booking=" + window.PushbookingData.id_booking + "&payment_method=" + window.WhichPaymentTypeSelected +"&method_bank="+ window.WhichPaymentBankSelected;

                    window.$.ajax({
                        type     : "GET",
                        cache    : false,
                        url      : DirectTransferURL,

                        success  : function(data)
                        {
                            window.GetDirectTransferData = window.ConvertDataJSON(data);

                            console.log(DirectTransferURL);
                            console.log(window.GetDirectTransferData);

                            window.InstantiateVerifyDirectPayment(window.GetDirectTransferData);

                            LoadingBlocker.remove();
                        },
                        error: function (error)
                        {
                            console.log(error);
                            LoadingBlocker.remove();
                        }
                    });
                }
            }

            // Blu --------------------------------------------------------------
            else if(MethodBankSelected == "blu")
            {
                PaymentVAText.remove();
                ButtonNextToPayment.remove();
            }
            // Card --------------------------------------------------------------
            else if(MethodTypeSelected == "Card")
            {
                let URLCOntinuePayCard = PaymentDataBasedOnType[0].url;
                PaymentVAText.remove();

                ButtonNextToPayment.style.display = "";
                ButtonNextToPaymentTextDesktop.innerHTML = window["ContinuePaymentBtnTxt" + window.CurrentCountryID];
                ButtonNextToPaymentTextMobile.innerHTML = window["ContinueTxt" + window.CurrentCountryID];
                ButtonNextToPayment.onclick = function()
                {
                    window.open(URLCOntinuePayCard, "_blank");
                }
            }
            // QRIS --------------------------------------------------------------
            else if(MethodTypeSelected == "QRIS")
            {
                PaymentVAText.style.display = "none";

                if(window.BookingDetailsData.transaction.status_payment == "Progress")
                {
                    ButtonNextToPayment.style.display = "";
                ButtonNextToPaymentTextDesktop.innerHTML = window["ContinuePaymentBtnTxt" + window.CurrentCountryID];
                ButtonNextToPaymentTextMobile.innerHTML = window["ContinueTxt" + window.CurrentCountryID];
                    ButtonNextToPayment.onclick = function()
                    {
                        window.open("/" + window.CurrentCountryID + "/payment.html?id_booking=" + BookingID, "_blank");
                    }
                }
            }
            // Virtual Account --------------------------------------------------------------
            else
            {
                let VANumberGet = BookingPaymentData.transaction.va_transactions[0].no_va;
                PaymentVAText.innerHTML = VANumberGet;

                ButtonNextToPayment.style.display = "";
                ButtonNextToPaymentTextDesktop.innerHTML = window["CopyVaButtonTxt" + window.CurrentCountryID];
                ButtonNextToPaymentTextMobile.innerHTML = window["CopyTxt" + window.CurrentCountryID];
                ButtonNextToPayment.onclick = function()
                {
                    window.CopyToClipboardItem(VANumberGet);
                }
            }
        }

    }


    // Display Setting Based On Booking (Not Payment) Status ----------------------------------

    if(BookingPaymentData != null && BookingStatus != null)
    {
        let WhichStatusToGet = "Check-in";

        let ThisStatusText = document.getElementById("CheckedInBookingCompleteLabelText");
        let ThisStatusBorder = document.getElementById("CheckedInBookingCompleteLabelBorder");

        let PaidPayAtHotelBorder = document.getElementById("PaidPayAtHotelBorder");
        document.getElementById("PaidPayAtHotelText").innerHTML = window["StatusPaidTxt" + window.CurrentCountryID];

        if(BookingStatus == "Check-in" || BookingStatus == "On Going") // If On Going/ Checked In ---------------------
        {
            WhichStatusToGet = "Check-in";
            PaidPayAtHotelBorder.style.display = "";
            document.getElementById("CheckedInBookingCompleteLabel").style.display = "";
        }
        else if(BookingStatus == "Complete") // If Booking Complete ---------------------
        {
            ThisStatusBorder.style.backgroundColor = "#ECFDF3";
            ThisStatusText.style.color = "#027A48";
            WhichStatusToGet = "Booking Completed";
            PaidPayAtHotelBorder.style.display = "";
        }
        else if(BookingStatus == "Cancel") // If Booking Cancelled ---------------------
        {
            ThisStatusBorder.style.backgroundColor = "#FEF3F2";
            ThisStatusText.style.color = "#B42318";
            WhichStatusToGet = "Booking Canceled";
        }

        for(let i = 0; i < window.TranslatedRoomStatusTxt.length; i++) // Apply The Text Change ---------------------
        {
            if(window.TranslatedRoomStatusTxt[i].status == WhichStatusToGet)
            {
                ThisStatusText.innerHTML = window.TranslatedRoomStatusTxt[i].text_lang[window.CurrentCountryID];
            }
        }
        
        console.log("WhichStatusToGet = " + WhichStatusToGet);
    }

}

// ======================================= PREPARE ALL PAYMENT INFO RIGHT =======================================

window.InstantiateBookingPaymentData = function()
{
    // RESET ALL ==================================================================================

    let YouSavedContainer = document.querySelectorAll('.YouSavedContainer');
    for(let i = 0; i < YouSavedContainer.length; i++)
    {
        YouSavedContainer[i].innerHTML = "";
    }

    let OriginalPriceContainer = document.querySelectorAll('.OriginalPriceContainer');
     for(let i = 0; i < OriginalPriceContainer.length; i++)
    {
        OriginalPriceContainer[i].innerHTML = "";
    }

    
    // VOUCHER DISC ==================================================================================
    let VoucherInfo = window.BookingDetailsData.voucher_bookings;
    if(window.BookingDetailsData.voucher_transaction != null && window.BookingDetailsData.voucher_transaction.length > 0)
        VoucherInfo = window.BookingDetailsData.voucher_transaction;
    //!!!!!!!!!!!!!!! WAIT VOUCHER DATA SHOWN
    if(VoucherInfo.length > 0)
    {
        for(let i = 0; i < YouSavedContainer.length; i++)
        {
            for(let j = 0; j < VoucherInfo.length; j++)
            {
                let ThisVoucherData = VoucherInfo[j].voucher;

                // Voucher Discount ----------------------------------------------------------------------------------------
                let VoucherDiscPerc = window.BookingDetailsData.transaction.disc_voucher || ThisVoucherData.discount;
                let VoucherDiscGet = window.BookingDetailsData.transaction.nom_disc_voucher;
                let MaxVoucherDiscount = window.BookingDetailsData.transaction.nom_disc_voucher || ThisVoucherData.max_discount;

                // Max Discount Text --------------------------------------------------------------------------
                let TotalVoucherDiscountText = "Disc " + VoucherDiscPerc + "%";
                if(MaxVoucherDiscount != 0)
                {
                    TotalVoucherDiscountText = TotalVoucherDiscountText + " Max " +  window.ConvertTextToRP(Math.round(MaxVoucherDiscount), 2, false, false);
                }

                let VoucherWrapper = document.createElement("div");
                VoucherWrapper.className = "PriceMainTextWrapper BlueContainerPrice BasicRadius";
                YouSavedContainer[i].append(VoucherWrapper);

                let Price1stWrapper = document.createElement("div");
                Price1stWrapper.className = "Price1stWrapper";
                VoucherWrapper.append(Price1stWrapper);

                let LabelGreyHeaderSmallerText = document.createElement("p");
                LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                LabelGreyHeaderSmallerText.innerHTML = "Voucher <span class='OrangeButton VoucherAppliedText'>Voucher Applied</span>";
                Price1stWrapper.append(LabelGreyHeaderSmallerText);

                let VoucherAppliedTextWrapper = document.createElement("div");
                VoucherAppliedTextWrapper.className = "PoinWithIconWrapper";
                VoucherAppliedTextWrapper.style.marginLeft = 0;
                Price1stWrapper.append(VoucherAppliedTextWrapper);

                let VoucherAppliedText = document.createElement("p");
                VoucherAppliedText.className = "SmallerRoomDescriptionText InterRegularTextFont";
                VoucherAppliedText.style.color = "#252525";
                VoucherAppliedText.innerHTML = TotalVoucherDiscountText;
                VoucherAppliedTextWrapper.append(VoucherAppliedText);

                let Price2ndWrapper = document.createElement("div");
                Price2ndWrapper.className = "Price2ndWrapper";
                VoucherWrapper.append(Price2ndWrapper);

                let VoucherTotalText = document.createElement("p");
                VoucherTotalText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                VoucherTotalText.innerHTML = window.ConvertTextToRP(VoucherDiscGet, 1, true, true);
                Price2ndWrapper.append(VoucherTotalText);
            }
        }
    }

    // ORIGINAL PRICE & YOU SAVED ==================================================================================

    let MaxDiscountGet;
    let DiscountPercentageFix;
    let TotalDiscountGet = 0;

    let ThisBookingDetailsData = window.BookingDetailsData.booking_details;

    for(let i = 0; i < ThisBookingDetailsData.length; i++)
    {
        // ----------------------------- PRICE -----------------------------
        let ThisOriginalPrice = ThisBookingDetailsData[i].room_original_price;

        // ----------------------------- DATE -----------------------------
        let CurrentDateArray = ThisBookingDetailsData[i].date.split("-");
        let CurrentDay = parseInt(CurrentDateArray[2]);
        let CurrentMonth = parseInt(CurrentDateArray[1]);
        let CurrentYear = parseInt(CurrentDateArray[0]);
        let DateToDisplay = CurrentDay.toString().padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][CurrentMonth - 1] + " " + CurrentYear;

        for(let j = 0; j < OriginalPriceContainer.length; j++)
        {
            let PriceSavedTextWrapper = document.createElement("div");
            PriceSavedTextWrapper.className = "PriceMainTextWrapper";
            OriginalPriceContainer[j].append(PriceSavedTextWrapper);

            let Price1stWrapper = document.createElement("div");
            Price1stWrapper.className = "Price1stWrapper";
            PriceSavedTextWrapper.append(Price1stWrapper);

            let LabelGreyHeaderSmallerText = document.createElement("p");
            LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            LabelGreyHeaderSmallerText.innerHTML = DateToDisplay;
            Price1stWrapper.append(LabelGreyHeaderSmallerText);


            let Price2ndWrapper = document.createElement("div");
            Price2ndWrapper.className = "Price2ndWrapper";
            PriceSavedTextWrapper.append(Price2ndWrapper);


            let DiscountValueText = document.createElement("p");
            DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            DiscountValueText.innerHTML = window.ConvertTextToRP(ThisOriginalPrice, 1, true, false);
            Price2ndWrapper.append(DiscountValueText);
        }

        // ----------------------------- DISCOUNT -----------------------------
        let DiscRoomPercentage = (parseInt(ThisBookingDetailsData[i].disc_room_mitra) + parseInt(ThisBookingDetailsData[i].disc_room_pingingo)) || 0;
        let DiscountNominal = (parseInt(ThisBookingDetailsData[i].price_discount_mitra) + parseInt(ThisBookingDetailsData[i].price_discount_pingingo)) || 0;

        TotalDiscountGet = TotalDiscountGet + DiscountNominal;
        
        if(i == 0)
        {
            let MitraMaxDisc = parseInt(ThisBookingDetailsData[i].max_disc_room_mitra) || 0;
            let PinginGoMaxDisc = parseInt(ThisBookingDetailsData[i].max_disc_room_pingingo) || 0;

            MaxDiscountGet = MitraMaxDisc + PinginGoMaxDisc;
            DiscountPercentageFix = DiscRoomPercentage;
        }


        for(let j = 0; j < YouSavedContainer.length; j++)
        {
            if(YouSavedContainer[j].getAttribute("is-one") == "false")
            {
                let PriceSavedTextWrapper = document.createElement("div");
                PriceSavedTextWrapper.className = "PriceMainTextWrapper";
                YouSavedContainer[j].append(PriceSavedTextWrapper);

                let Price1stWrapper = document.createElement("div");
                Price1stWrapper.className = "Price1stWrapper";
                PriceSavedTextWrapper.append(Price1stWrapper);

                let LabelGreyHeaderSmallerText = document.createElement("p");
                LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                LabelGreyHeaderSmallerText.innerHTML = DateToDisplay;
                Price1stWrapper.append(LabelGreyHeaderSmallerText);

                let DiscountText = document.createElement("p");
                DiscountText.className = "SmallerRoomDescriptionText InterRegularTextFont";
                DiscountText.style.color = "#252525";
                DiscountText.innerHTML = "Disc " + DiscRoomPercentage + "%";
                Price1stWrapper.append(DiscountText);

                let Price2ndWrapper = document.createElement("div");
                Price2ndWrapper.className = "Price2ndWrapper";
                PriceSavedTextWrapper.append(Price2ndWrapper);

                let DiscountValueText = document.createElement("p");
                DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                DiscountValueText.innerHTML = window.ConvertTextToRP(DiscountNominal, 1, true, true);
                Price2ndWrapper.append(DiscountValueText);
            }
        }
    }

    for(let i = 0; i < YouSavedContainer.length; i++)
    {
        if(YouSavedContainer[i].getAttribute("is-one") == "true")
        {
            let PriceSavedTextWrapper = document.createElement("div");
            PriceSavedTextWrapper.className = "PriceMainTextWrapper";
            YouSavedContainer[i].append(PriceSavedTextWrapper);

            let Price1stWrapper = document.createElement("div");
            Price1stWrapper.className = "Price1stWrapper";
            PriceSavedTextWrapper.append(Price1stWrapper);

            let LabelGreyHeaderSmallerText = document.createElement("p");
            LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            LabelGreyHeaderSmallerText.innerHTML = "Disc " + DiscountPercentageFix + "%";
            Price1stWrapper.append(LabelGreyHeaderSmallerText);

            let DiscountText = document.createElement("p");
            DiscountText.className = "SmallerRoomDescriptionText InterRegularTextFont";
            DiscountText.style.color = "#252525";
            if(MaxDiscountGet == 0)
            {
                DiscountText.className = "SmallerRoomDescriptionText InterItalicTextFont";
                DiscountText.innerHTML = window["NoMaxDiscountTxt" + window.CurrentCountryID];
            }
            else
            {
                DiscountText.innerHTML = "Max " + window.ConvertTextToRP(MaxDiscountGet, 2, true, false);
            }
            Price1stWrapper.append(DiscountText);


            let Price2ndWrapper = document.createElement("div");
            Price2ndWrapper.className = "Price2ndWrapper";
            PriceSavedTextWrapper.append(Price2ndWrapper);


            let DiscountValueText = document.createElement("p");
            DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            DiscountValueText.innerHTML = window.ConvertTextToRP(TotalDiscountGet, 1, true, true);
            Price2ndWrapper.append(DiscountValueText);
        }
    }
    

    // if(window.FormPaymentHotelData.voucher.id_voucher != null)
    // {
    //     let VoucherWrapper = document.createElement("div");
    //     VoucherWrapper.className = "PriceMainTextWrapper BlueContainerPrice BasicRadius";
    //     YouSavedPriceContainer.append(VoucherWrapper);

    //     let Price1stWrapper = document.createElement("div");
    //     Price1stWrapper.className = "Price1stWrapper";
    //     VoucherWrapper.append(Price1stWrapper);

    //     let LabelGreyHeaderSmallerText = document.createElement("p");
    //     LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
    //     LabelGreyHeaderSmallerText.innerHTML = "Voucher <span class='OrangeButton VoucherAppliedText'>Voucher Applied</span>";
    //     Price1stWrapper.append(LabelGreyHeaderSmallerText);

    //     let PoinWithIconWrapper = document.createElement("div");
    //     PoinWithIconWrapper.className = "PoinWithIconWrapper";
    //     PoinWithIconWrapper.style.marginLeft = 0;
    //     Price1stWrapper.append(PoinWithIconWrapper);

    //     let PoinIconIMG = document.createElement("img");
    //     PoinIconIMG.src="/Assets/images/ButtonIcon/coin-icon.svg";
    //     PoinWithIconWrapper.append(PoinIconIMG);

    //     let PingPoinText = document.createElement("p");
    //     PingPoinText.className = "SmallerRoomDescriptionText InterRegularTextFont";
    //     PingPoinText.style.color = "#252525";
    //     PingPoinText.innerHTML = "1 Poin = 100 Rp";
    //     PoinWithIconWrapper.append(PingPoinText);

    //     let Price2ndWrapper = document.createElement("div");
    //     Price2ndWrapper.className = "Price2ndWrapper";
    //     VoucherWrapper.append(Price2ndWrapper);

    //     let VoucherTotalText = document.createElement("p");
    //     VoucherTotalText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
    //     VoucherTotalText.innerHTML = "Rp ";
    //     Price2ndWrapper.append(VoucherTotalText);
    // }


    // NIGHTS TEXT ==================================================================================

    let HowManyNightText = document.querySelectorAll('.HowManyNightText');
    let HowManyDaysText = window.NightTextDisplayer(ThisBookingDetailsData.length);

    HowManyNightText.forEach(ThisText =>
    {
        ThisText.innerHTML = HowManyDaysText;
    });

    // ADD ONS ====================================================================================

    let AddOnsData = window.BookingDetailsData.booking_add_ons;
    let ThisAddOnWrapper = document.querySelectorAll('.ThisAddOnWrapper');
    ThisAddOnWrapper.forEach(ThisAddOnContainer =>
    {
        ThisAddOnContainer.remove();
    });

    if(AddOnsData != null)
    {
        console.log("AddOnsData", AddOnsData);
        for(let i = 0; i < AddOnsData.length; i++)
        {
            // Prepare the Name To Display --------------------------------
            let NameToDisplay = AddOnsData[i]["add_on_name_" + window.CurrentCountryID];
            if(AddOnsData[i].is_required != "0")
            {
                NameToDisplay = NameToDisplay + "<span style=\"color: #c10000\">*</span>";
            }
            if(AddOnsData[i].pricing_type == "night")
            {
                NameToDisplay = NameToDisplay + " x" + (AddOnsData[i].qty * AddOnsData[i].total_night) + " <span class='InterMediumItalicTextFont'>(" + AddOnsData[i].qty + "x" + window.NightTextDisplayer(AddOnsData[i].total_night) + ")</span>";
            }
            else
            {
                NameToDisplay = NameToDisplay + " x" + AddOnsData[i].qty;
            }

            // Instantiate to Not Summarized Panel ------------------------------------------------------------
            if(PriceContainerToAddAddOn != null)
            {
                for(let j = 0; j < PriceContainerToAddAddOn.length; j++)
                {
                    // Instantiate --------------------------------
                    let PriceSavedTextWrapper = document.createElement("div");
                    PriceSavedTextWrapper.className = "PriceMainTextWrapper";
                    PriceContainerToAddAddOn[j].append(PriceSavedTextWrapper);

                    let Price1stWrapper = document.createElement("div");
                    Price1stWrapper.className = "Price1stWrapper";
                    PriceSavedTextWrapper.append(Price1stWrapper);

                    let LabelGreyHeaderSmallerText = document.createElement("p");
                    LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                    LabelGreyHeaderSmallerText.innerHTML = NameToDisplay;
                    Price1stWrapper.append(LabelGreyHeaderSmallerText);


                    let Price2ndWrapper = document.createElement("div");
                    Price2ndWrapper.className = "Price2ndWrapper";
                    PriceSavedTextWrapper.append(Price2ndWrapper);


                    let DiscountValueText = document.createElement("p");
                    DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                    DiscountValueText.innerHTML = window.ConvertTextToRP(AddOnsData[i].total_price, 1, true, false);
                    Price2ndWrapper.append(DiscountValueText);
                }
            }



            // Instantiate to Summarized Panel ------------------------------------------------------------
            // for(let j = 0; j < SummarizedOriginalPriceContainer.length; j++)
            // {
            //     // Instantiate --------------------------------
            //     let PriceSavedTextWrapper = document.createElement("div");
            //     PriceSavedTextWrapper.className = "PriceMainTextWrapper ThisAddOnWrapper";
            //     SummarizedOriginalPriceContainer[j].append(PriceSavedTextWrapper);

            //     let Price1stWrapper = document.createElement("div");
            //     Price1stWrapper.className = "Price1stWrapper";
            //     PriceSavedTextWrapper.append(Price1stWrapper);

            //     let LabelGreyHeaderSmallerText = document.createElement("p");
            //     LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            //     LabelGreyHeaderSmallerText.innerHTML = NameToDisplay;
            //     Price1stWrapper.append(LabelGreyHeaderSmallerText);

            //     let Price2ndWrapper = document.createElement("div");
            //     Price2ndWrapper.className = "Price2ndWrapper";
            //     PriceSavedTextWrapper.append(Price2ndWrapper);

            //     let DiscountValueText = document.createElement("p");
            //     DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            //     DiscountValueText.innerHTML = window.ConvertTextToRP(AddOnsData[i].total_price, 1, true, false);
            //     Price2ndWrapper.append(DiscountValueText);
            // }
        }
    }

    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! STILL NOT EXIST
    // DOWN PAYMENT PERCENTAGE TEXT ==================================================================================
    let DownPaymentPercText = document.querySelectorAll('.DownPaymentPercText');
    let BookingPercentage = window.BookingDetailsData.dp_percentage;
    DownPaymentPercText.forEach(ThisText => // Percentage
    {
        ThisText.innerHTML = window["PayDownPaymentTxt" + window.CurrentCountryID] + " (" +  Math.round(BookingPercentage) +"%)";
    });

    // FINAL ORIGINAL PRICE ==================================================================================
    let OriginalPriceText = document.querySelectorAll('.OriginalPriceText');
    let OriginalPriceCalculated = 0;
    window.BookingDetailsData.booking_details.forEach(bookingdata => {
        OriginalPriceCalculated = OriginalPriceCalculated + parseInt(bookingdata.room_original_price);
    });
    console.log("OriginalPriceCalculated = " + OriginalPriceCalculated)
    OriginalPriceText.forEach(ThisText =>
    {
        ThisText.innerHTML = window.ConvertTextToRP(OriginalPriceCalculated, parseInt(ThisText.getAttribute("rp-type")), (ThisText.getAttribute("final-zero").toLowerCase() === "true"), false);
    });

    let FinalPriceText = document.querySelectorAll('.FinalPriceText');
    let FinalPriceCalculated = (parseInt(window.BookingDetailsData?.transaction?.gross_amount) - parseInt(window.BookingDetailsData?.transaction?.nom_disc_voucher) - parseInt(window.BookingDetailsData?.transaction?.nom_disc_platform)) || (parseInt(window.BookingDetailsData.status_pay_at_hotel.pay_at_hotel) + parseInt(window.BookingDetailsData.down_payment));
    FinalPriceText.forEach(ThisText =>
    {
        ThisText.innerHTML = window.ConvertTextToRP(FinalPriceCalculated, parseInt(ThisText.getAttribute("rp-type")), (ThisText.getAttribute("final-zero").toLowerCase() === "true"), false);
    });

    // PAY AT HOTEL PRICE ==================================================================================
    let PayAtHotelPriceText = document.querySelectorAll('.PayAtHotelPriceText');
    let PayAtHotelPriceCalculated = window.BookingDetailsData.status_pay_at_hotel.pay_at_hotel;
    PayAtHotelPriceText.forEach(ThisText =>
    {
        ThisText.innerHTML = window.ConvertTextToRP(PayAtHotelPriceCalculated, parseInt(ThisText.getAttribute("rp-type")), (ThisText.getAttribute("final-zero").toLowerCase() === "true"), false);
    });

    // DP TEXT UPDATE ==================================================================================
    let DownPaymentText = document.querySelectorAll('.DownPaymentText');
    let DownPaymentPriceCalculated = window.BookingDetailsData.transaction.final_amount;
    // let DownPaymentPriceCalculated = window.BookingDetailsData.down_payment;
    DownPaymentText.forEach(ThisText =>
    {
        ThisText.innerHTML = window.ConvertTextToRP(DownPaymentPriceCalculated, parseInt(ThisText.getAttribute("rp-type")), (ThisText.getAttribute("final-zero").toLowerCase() === "true"), false);
    });
}


// =================================== EXPREZY DETAILS ====================================

window.LoadExprezyDataBookingDetails = function(BookingReferences, maininfo, basicinfo, hotelid)
{
    let CheckExprezyBookingDetailURL = "/v2/bookings/" + BookingReferences + "/exprezy";
    //!!!!!!!!!!!!
    window.CallApiAxios({
        method: "GET",
        url: CheckExprezyBookingDetailURL,
    }).then(res =>
    {
        console.log(CheckExprezyBookingDetailURL);
        console.log(res);

        if(res.status == 200)
        {
            window.ExprezyData = res.data.data;
            console.log(window.ExprezyData);

            // If Not Null User Can Write New Exprezy ----------------------------------------------------------------------
            document.getElementById("SubmitExperienceContainer").remove();

            // Instantiate Exprezy -----------------------------------------------------------------------------------------------------

            if(window.ExprezyData != null && window.ExprezyData.length != 0)
            {
                let LocationToDisplay = window.HotelDetails.city_region + ", " + window.HotelDetails.province;
                let UserDataToPush =
                {
                    "profile_picture": basicinfo.prof_pic,
                    "first_name": basicinfo.first_name,
                    "last_name": basicinfo.last_name,
                }
                window.ExprezyData[0].user = UserDataToPush;

                window.InstantiateAllPingExprezyData(window.ExprezyData, null, maininfo, hotelid, LocationToDisplay);
            }
        }
    })
    .catch(err =>
    {
        console.error(err);
        if(err.data.message == "No experiences found for this booking" && (window.BookingDetailsData.status_pay_at_hotel.status == "Check-in" || window.BookingDetailsData.status_pay_at_hotel.status == "Complete"))
        {
            document.getElementById("SubmitExperienceContainer").style.display = "";
            document.getElementById("YouHaveFinishedBookMesText").innerHTML = window["YouHaveFinishedStayingExprezyTxt" + window.CurrentCountryID](window.HotelDetails.hotel_name);
            window.SubmitExperienceButton.onclick = function()
            {
                window.OpenViewMoreExperiences(null, BookingReferences, maininfo, hotelid);
            }

            // If Add New FROM EMAIL --------------------------------------------------------
            if(URLSpecialBookingDetails != null)
            {
                if(AllowSpecialAddNew == true)
                {
                    window.OpenViewMoreExperiences(null, window.BookingDetailsData.booking_reference, maininfo, hotelid);
                }
                else
                {
                    window.OpenViewMoreExperiences(null, null, maininfo, hotelid);
                }
            }
        }
    });
}